import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";
import { useWorkspace } from "@/api/auth/queries";
import { useMemo } from "react";
import { SubscriptionIntervals } from "@/types/billing";
import ShopifyBillingButton from "@/components/billing/ShopifyBillingButton";

export default function BillingInformation() {
  const workspace = useWorkspace();
  const currentPlan = workspace?.active_subscription.plan;

  const currentPlanPrice = useMemo(() => {
    if (!currentPlan) {
      return 0;
    }
    if (currentPlan.interval === SubscriptionIntervals.MONTHLY) {
      return (currentPlan.cost_per_month / 100).toFixed(2);
    }
    return Math.ceil((currentPlan.cost_per_month * 12) / 100);
  }, [currentPlan]);

  const currentPlanInterval = useMemo(() => {
    if (!currentPlan) {
      return "month";
    }
    if (currentPlan.interval === SubscriptionIntervals.MONTHLY) {
      return "month";
    }
    return "year";
  }, [currentPlan]);

  if (!currentPlan) {
    return null;
  }

  return (
    <div className="w-full">
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-2xl">Current Plan</CardTitle>
          <CardDescription>Your current subscription details</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl font-semibold">{currentPlan.name}</h2>
            <Badge variant="secondary" className="text-lg px-4 py-2">
              {currentPlanPrice != 0
                ? `$${currentPlanPrice}/${currentPlanInterval}`
                : "Free"}
            </Badge>
          </div>
          <ul className="space-y-3 mb-6">
            {currentPlan.features.map((feature, index) => (
              <li key={index} className="flex items-center">
                <Check className="mr-3 h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-lg">{feature}</span>
              </li>
            ))}
          </ul>
          <div className="bg-muted p-4 rounded-lg">
            <p className="text-sm text-muted-foreground">
              Billing is managed through Shopify. Click the button below to
              change your plan or update billing information.
            </p>
          </div>
        </CardContent>
        <CardFooter>
          <ShopifyBillingButton className="py-6 text-lg w-full" />
        </CardFooter>
      </Card>
    </div>
  );
}
